export const theme = {
  colors: {
    // Primary colors (aqua from SplitStep brand)
    primary: '#72d2ff',
    primaryHover: '#8ddcff',
    primaryDark: '#183b7e',
    accent: '#ffd040',

    // Background colors (deep navy from SplitStep brand)
    background: '#001221',
    surface: '#0a1e38',
    surfaceHover: '#0d2a4a',

    // Text colors (high contrast on dark backgrounds)
    text: '#ffffff',
    textSecondary: '#a0aec0',
    textMuted: '#6b7d99',

    // Annotation colors
    stroke: '#ffb86c',
    bounce: '#8be9fd',
    inFlight: '#ff79c6',
    net: '#bd93f9',

    // Court keypoint colors
    courtBaseline: '#50fa7b',
    courtServiceLine: '#ffb86c',
    courtCenterLine: '#8be9fd',
    courtOverlay: 'rgba(255, 255, 255, 0.1)',
    courtLine: 'rgba(255, 255, 255, 0.6)',
    courtLineBaseline: '#50fa7b',
    courtLineService: '#ffb86c',

    // Player colors
    playerRed: '#ff5555',
    playerGreen: '#50fa7b',
    playerMode: '#ffffff',

    // Status colors
    error: '#ff5555',
    success: '#50fa7b',
    warning: '#ffb86c',

    // Border colors (subtle aqua-tinted)
    border: 'rgba(114, 210, 255, 0.25)',
    borderLight: 'rgba(114, 210, 255, 0.1)',

    // Shadow colors
    shadow: 'rgba(0, 0, 0, 0.4)',
    shadowLight: 'rgba(0, 0, 0, 0.25)',
  },
  
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '20px',
    xxl: '24px',
    xxxl: '32px',
    xxxxl: '40px',
  },
  
  typography: {
    fontFamily: 'Roboto, sans-serif',
    fontSizes: {
      xs: '10px',
      sm: '12px',
      base: '14px',
      lg: '15px',
      xl: '16px',
      xxl: '18px',
      xxxl: '24px',
      xxxxl: '28px',
    },
    fontWeights: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    letterSpacing: {
      tight: '0.3px',
      normal: '0.5px',
      wide: '1px',
    },
  },
  
  borderRadius: {
    sm: '4px',
    md: '6px',
    lg: '8px',
    xl: '10px',
    xxl: '12px',
    full: '50%',
  },
  
  shadows: {
    sm: '0 2px 8px rgba(0, 0, 0, 0.3)',
    md: '0 4px 12px rgba(0, 0, 0, 0.4)',
    lg: '0 8px 24px rgba(0, 0, 0, 0.5)',
    glow: '0 0 20px rgba(114, 210, 255, 0.15)',
    dropShadow: 'drop-shadow(0 2px 8px rgba(0, 0, 0, 0.6))',
  },
  
  transitions: {
    fast: '0.1s ease',
    normal: '0.2s ease',
    slow: '0.3s ease',
  },
  
  // Video dimensions
  video: {
    width: 1280,
    height: 720,
  },
  
  // Timeline dimensions
  timeline: {
    height: 40,
    viewportWidth: 1280,
  },
};

export default theme; 